<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="vx-row">
                <div class="vx-col md:w-1/4 sm:w-auto">
                    <label class="vs-input--label">{{ $t('navMenu.school') }}</label>
                    <v-select class="" v-model="selectedOrganizationBranch" :clearable="false"
                              :options="organizationBranchOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
                <div class="vx-col md:w-1/4 sm:w-auto">
                    <label class="vs-input--label">{{ $t('classRoom.classRoom') }}</label>
                    <v-select class="" v-model="selectedClass" :clearable="false"
                              :options="classOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
                <div class="vx-col md:w-1/4 sm:w-auto">
                    <label class="vs-input--label">{{ $t('qrCode.status') }}</label>
                    <v-select class="" v-model="selectedStatus" :clearable="false"
                              :options="statusOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
                <div class="vx-col md:w-1/4 sm:w-auto">
                    <label class="vs-input--label">{{ $t('menuOrganization.studentName') }}</label>
                    <vs-input v-model="studentName" class="w-full" placeholder="Tìm kiếm theo tên ..."></vs-input>
                </div>
            </div>
            <div class="flex flex-wrap items-center mt-5">
                <div class="flex flex-grow">
                    <vs-button
                        v-show="isPermissionAdd()"
                        @click="addEmployee"
                        color="primary"
                        icon-pack="feather"
                        icon="icon-plus">
                        {{ $t('button.addStudent') }}
                    </vs-button>
                    <vs-button iconPack="feather" icon="icon-download" color="primary" type="border" class="ml-2"
                               @click="downloadTemplate">{{ $t('attendance.downloadTemplate') }}
                    </vs-button>
                    <vs-button iconPack="feather" icon="icon-upload" color="primary" type="border" class="ml-2"
                               @click="$refs.fileUpload.click()">{{ $t('attendance.import') }}
                    </vs-button>
                    <vs-button iconPack="feather" icon="icon-download" color="primary" type="border" class="ml-2"
                               @click="exportListStudent" v-if="selectedOrganizationBranchValue">
                        {{ $t('attendance.exportBySchool') }}
                    </vs-button>
                    <vs-button iconPack="feather" icon="icon-download" color="primary" type="border" class="ml-2"
                               @click="generateReport" v-if="classId">{{ $t('attendance.exportByClass') }}
                    </vs-button>
                    <vs-button @click="confirmDeleteMultiple" color="danger" type="border" icon-pack="feather"
                               icon="icon-trash-2"
                               class="ml-2" v-if="isSelected">
                               {{ $t('button.deleteALot') }}
                    </vs-button>

                    <input ref="fileUpload" type="file" id="fileUpload" accept=".xlsx, .xls, .csv, .xlsm, .xlsb"
                           class="hidden" @change="uploadFile($event)">

                </div>

                <vs-button @click="searchData" color="primary" icon="icon-search" icon-pack="feather"
                           class="sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4">{{ $t('button.search') }}
                </vs-button>
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue style="height: 55vh"
                         ref="agGridTable"
                         :gridOptions="gridOptions"
                         class="ag-theme-material w-100 my-4 ag-grid-table"
                         :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :rowData="studentData"
                         :animateRows="true"
                         :localeText="  {noRowsToShow: this.$t('menuCustomer.noRowsToShow')} "
                         :paginationPageSize="pageSize"
                         :pagination="true"
                         @grid-ready="onGridReady"
                         :autoSizeStrategy="autoSizeStrategy"
                         :suppressRowClickSelection="true"
                         :rowSelection="'multiple'"
                         @row-selected="onRowSelected"
                         tooltipShowDelay="0"
                         tooltipHideDelay="5000"
                         :tooltipMouseTrack="true">
            </ag-grid-vue>

            <div class="vx-row" v-if="totalElements > 0">
                <div class="w-full flex">
                    <div style="min-width:200px">
                        <span class="content-page font-bold ml-4">{{ $t('dashboard.display') }}: </span><span class="text-page">{{
                            countElementPage > totalElements ? totalElements : countElementPage
                        }} /
                            {{ totalElements }} </span>
                    </div>
                    <vs-pagination
                        :total="totalPages"
                        v-model="currentPage"
                        @change="loadPage"/>
                </div>
            </div>

        </div>

        <vs-popup class="holamundo popupError" title="Lỗi tải lên tệp nhân viên" :active.sync="popupErrorImport">
            <div class="">
                <div>
                    <vs-table stripe :data="errorData" pagination max-items="10">
                        <template slot="thead">
                            <vs-th>{{ $t('button.numericalOrder') }}</vs-th>
                            <vs-th> {{ $t('button.dataFields') }}</vs-th>
                            <vs-th> {{ $t('button.row') }}</vs-th>
                            <vs-th> {{ $t('button.colum') }}</vs-th>
                            <vs-th> {{ $t('button.error') }}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(item, indextr) in data">
                                <vs-td> {{ item.stt }}</vs-td>

                                <vs-td> {{ item.header }}</vs-td>

                                <vs-td> {{ item.rowNumError }}</vs-td>

                                <vs-td> {{ item.colChar }}</vs-td>

                                <vs-td> {{ item.message }}</vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>
            </div>
        </vs-popup>

    </div>
</template>

<script>
import vSelect from 'vue-select'
import {AgGridVue} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CellRendererActions from "./cell-renderer/CellRendererActions.vue"
import Pagination from "../../ui-elements/Pagination.vue"
import CellRendererStatus from "./cell-renderer/CellRendererStatus";
import {isRouter} from "../../../store/permission"
import {constRouter} from "../../../store/constant"
import authConfig from '@/../auth_config.json';

import {ClientSideRowModelModule} from '@ag-grid-community/client-side-row-model';
import {ModuleRegistry} from '@ag-grid-community/core';
import moment from "moment";
// Register the required feature modules with the Grid
ModuleRegistry.registerModules([ClientSideRowModelModule]);


export default {
    components: {
        AgGridVue,
        vSelect,
        // Cell Renderer
        CellRendererStatus,
        CellRendererActions,
        Pagination
    },
    data() {
        return {
            enabled: null,
            searchQuery: "",
            checkEmployee: true,
            // AgGrid
            gridApi: null,
            gridOptions: {},
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: 'STT',
                    field: 'stt',
                    minWidth: 120,
                    headerCheckboxSelection: true,
                    headerCheckboxSelectionFilteredOnly: true,
                    checkboxSelection: true,
                },

                {
                    headerName: this.$t('menuOrganization.studentCode'),
                    field: 'studentCode',
                    minWidth: 200,
                    tooltipField: 'studentCode',
                },
                {
                    headerName: this.$t('menuOrganization.studentName'),
                    field: 'fullName',
                    minWidth: 200,
                    tooltipField: 'fullName',
                },
                {
                    headerName: this.$t('navMenu.school'),
                    field: 'schoolName',
                    minWidth: 150,
                    tooltipField: 'schoolName',
                },
                {
                    headerName: this.$t('menuOrganization.className'),
                    field: 'className',
                    minWidth: 150,
                    tooltipField: 'className',
                },
                {
                    headerName: this.$t('menuOrganization.address'),
                    field: 'fullAddress',
                    minWidth: 300,
                    tooltipField: 'fullAddress',
                },
                {
                    headerName: this.$t('menuOrganization.phoneNumber'),
                    field: 'phoneNumber',
                    minWidth: 200,
                    tooltipField: 'phoneNumber',
                },
                {
                    headerName: this.$t('menuOrganization.schoolYear'),
                    field: 'schoolYear',
                    minWidth: 200,
                    tooltipField: 'schoolYear',
                },
                {
                    headerName: this.$t('menuOrganization.status'),
                    field: 'enabled',
                    cellRenderer: 'CellRendererStatus',
                    minWidth: 150,
                },
                {
                    headerName: this.$t('menuOrganization.createdDate'),
                    field: 'createdDateStr',
                    minWidth: 200,
                    tooltipField: 'createdDateStr',
                },
                {
                    headerName: this.$t('menuOrganization.modifiedDate'),
                    field: 'modifiedDateStr',
                    minWidth: 200,
                    tooltipField: 'modifiedDateStr',
                },
                {
                    headerName: this.$t('button.actions'),
                    field: 'actions',
                    minWidth: 250,
                    cellRenderer: 'CellRendererActions',
                    suppressSizeToFit: true,
                    pinned: 'right'
                },
            ],
            studentData: [],
            organizationBranchOptions: [],
            selectedOrganizationBranchValue: null,
            classOptions: [],
            classId: null,
            countElementPage: 0,
            totalElements: 0,
            pageNumber: 1,
            pageSize: 50,
            totalPages: 0,
            currentPage: 1,
            statusOptions: [
                {value: null, label: this.$t('menuOrganization.all')},
                {value: true, label: this.$t('attendance.onSchool')},
                {value: false, label: this.$t('attendance.offSchool')},
                {value: 2, label: 'Chưa có lớp'}
            ],
            studentName: null,
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            popupErrorImport: false,
            errorData: [],
            isSelected: false,
            dataSelected: [],
        }
    },
    created() {
        this.initScreen()
    },
    watch: {
        '$store.state.isUpdateStudent'(val) {
            if (val) {
                this.searchData();
                this.$store.commit('UPDATE_STUDENT', false);
            }
        }
    },
    computed: {
        selectedOrganizationBranch: {
            get() {
                let obj = this.organizationBranchOptions.find(x => x.value == this.selectedOrganizationBranchValue)
                if (!obj) return
                return {
                    label: obj.label,
                    value: obj.value
                }
            },
            async set(obj) {
                this.selectedOrganizationBranchValue = obj ? obj.value : null
                await this.getDataClass()
            }
        },
        selectedClass: {
            get() {
                let obj = this.classOptions.find(x => x.value == this.classId)
                if (!obj) return
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.classId = obj ? obj.value : null
            }
        },
        selectedStatus: {
            get() {
                let obj = this.statusOptions.find(x => x.value == this.enabled)
                if (!obj) return
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.enabled = obj ? obj.value : null
            }
        },
    },

    methods: {
        isPermissionAdd() {
            return isRouter(this, constRouter.student_add)
        },

        searchData() {
            // this.currentPage = 1;
            // if (this.gridApi) this.gridApi.paginationGoToPage(this.currentPage - 1)
            this.pageNumber = 1;
            this.currentPage = 1;
            this.getStudentData();
        },

        loadPage: function (currentPage) {
            if (this.pageNumber != (parseInt(currentPage))) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) : 1;
                this.getStudentData();
            }
        },

        addEmployee() {
            if (this.organizationBranchOptions.length == 0 && !this.selectedOrganizationBranchValue) {
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: this.$t('button.addEmployee'),
                    text: `Chưa có chi nhánh nào, vui lòng thêm chi nhánh trước.`,
                    accept: this.acceptGoToAddBranch,
                    acceptText: this.$t('button.agree'),
                    cancelText: this.$t('button.cancel')
                })
                return;
            }
            if (this.selectedOrganizationBranchValue == null) {
                // let userInfo = JSON.parse(localStorage.getItem('userInfo'));
                // this.selectedOrganizationBranchValue = userInfo.organization.id
                this.selectedOrganizationBranchValue = this.organizationBranchOptions[1].value
                this.$router.push(`/user/student-infomation?branch_id=${this.selectedOrganizationBranchValue}`).catch(() => {
                });
            }
            if (this.selectedOrganizationBranchValue) {
                this.$router.push(`/user/student-infomation?branch_id=${this.selectedOrganizationBranchValue}`).catch(() => {
                });
            }
        },
        acceptGoToAddBranch() {
            this.$router.push(`/user/add-organization-branch`).catch(() => {
            });
        },
        onGridReady(params) {
            this.gridApi = params.api;
        },

        UpdateModelFaceBank() {
            this.$vs.loading();
            this.$crm.get('/face-bank-model/version/update').then(() => {
                this.$vs.loading.close();
                setTimeout(() => {
                    if (this.$store.state.windowWidth > 1024) {
                        this.gridApi.sizeColumnsToFit();
                    }
                }, 100);
                return this.$vs.notify({
                    text: this.$t('menuOrganization.dataUpdate'),
                    iconPack: 'feather',
                    icon: 'icon-CheckCircleIcon',
                    color: 'success'
                });
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: this.$t('message.error'),
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });

            });
        },

        async initScreen() {
            let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
            if (branchList.length === 0) {
                return this.$vs.notify({
                    text: this.$t('warningMenuOrganization.emptyEmployee'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            this.organizationBranchOptions = branchList.filter(x => x.organizationBranchType === 3).map(item => {
                return {value: item.id, label: item.organizationBranchName}
            });
            this.organizationBranchOptions.unshift({value: null, label: this.$t('menuOrganization.all')})
            let branchId = this.$route.query.branch_id;
            if (branchId) {
                this.selectedOrganizationBranchValue = branchId
                // index = this.organizationBranchOptions.findIndex(item => item.value == branchId)
            }
            // this.selectedOrganizationBranch = this.organizationBranchOptions[index > -1 ? index : 0];
            await this.getDataClass()
            this.getStudentData();
        },

        getStudentData() {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            this.$vs.loading();
            let payload = {
                enabled: this.enabled,
                organizationBranchId: this.selectedOrganizationBranchValue,
                organizationId: userInfo.organization.id,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                sort: 'id',
                classId: this.classId,
                fullName: this.studentName
            }
            if (this.enabled === 2) payload.studentNotInClass = true;
            this.studentData = [];
            this.$crm.post('/school-student/search', payload).then((response) => {
                this.$vs.loading.close();
                if (response.data.content && response.data.content.length > 0) {
                    this.studentData = response.data.content.map(el => {
                        el.stt = (this.pageNumber - 1) * this.pageSize + response.data.content.indexOf(el) + 1
                        el.createdDateStr = el.createdDate ? moment(el.createdDate).format('DD/MM/YYYY') : null
                        el.modifiedDateStr = el.modifiedDate ? moment(el.modifiedDate).format('DD/MM/YYYY') : null
                        el.schoolYear = (el.startYear && el.endYear) ? (el.startYear + ' - ' + el.endYear) : null
                        let object = this.classOptions.find(item => item.value && el.classIds && el.classIds.includes(item.value));
                        el.className = object ? object.label : null
                        let school = this.organizationBranchOptions.find(x => x.value === el.organizationBranchId)
                        el.schoolName = school ? school.label : null
                        return el
                    });
                }

                this.countElementPage = this.currentPage * this.pageSize;
                this.totalElements = response.data.totalElements;
                this.totalPages = response.data.totalPages;
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Có lỗi sảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        getDataClass() {
            return new Promise((resolve, reject) => {
                let userInfo = JSON.parse(localStorage.getItem('userInfo'));
                this.$vs.loading();
                let schoolStudentSearchDTO = {
                    organizationBranchId: this.selectedOrganizationBranchValue,
                    organizationId: userInfo.organization.id,
                    status: true,
                }
                this.$crm.post('/school-classroom/get-all-class', schoolStudentSearchDTO).then(res => {
                    this.classOptions = res.data.map(el => {
                        return {
                            value: el.id,
                            label: el.className
                        }
                    })
                    this.classOptions.unshift({value: null, label: this.$t('menuOrganization.all')})
                    this.$vs.loading.close();
                    resolve(res)
                }).catch((err) => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Có lỗi sảy ra!',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        generateReport() {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            let payload = {
                enabled: this.enabled,
                organizationBranchId: this.selectedOrganizationBranchValue,
                organizationId: userInfo.organization.id,
                sort: 'id',
                classId: this.classId,
                fullName: this.studentName,
            }
            if (this.enabled === 2) payload.studentNotInClass = true;

            this.$vs.loading()
            this.$crm.post('/school-student/export', payload).then(res => {
                window.open(authConfig.crmDomain + "file/" + res.data.fileName + "?access_token=" + localStorage.getItem("access_token"), "_blank")
                this.$vs.loading.close()
                this.$vs.notify({
                    text: 'Xuất báo cáo thành công !',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'primary'
                })
            }).catch(err => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },

        exportListStudent() {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            let payload = {
                enabled: this.enabled,
                organizationBranchId: this.selectedOrganizationBranchValue,
                organizationId: userInfo.organization.id,
                sort: 'id',
                classId: this.classId,
                fullName: this.studentName,
            }
            if (this.enabled === 2) payload.studentNotInClass = true;

            this.$vs.loading()
            this.$crm.post('/school-student/export-by-school', payload).then(res => {
                window.open(authConfig.crmDomain + "file/" + res.data.fileName + "?access_token=" + localStorage.getItem("access_token"), "_blank")
                this.$vs.loading.close()
                this.$vs.notify({
                    text: 'Xuất báo cáo thành công !',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'primary'
                })
            }).catch(err => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },

        downloadTemplate() {
            this.$vs.loading();
            this.$crm.get(`/school-student/download-template`).then(res => {
                window.open(authConfig.crmDomain + "file/beauty/" + res.data + "?access_token=" + localStorage.getItem("access_token"), "_blank");
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });

        },

        isExcel(file) {
            return /\.(xlsx|xls|csv|xlsm|xlsb)$/.test(file.name)
        },
        uploadFile(e) {
            let file = [...e.target.files];
            if (!this.isExcel(file[0])) {
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: 'Chỉ hỗ trợ tệp có định dạng .xlsx, .xls, .csv, .xlsm, .xlsb',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                })
            }

            let formData = new FormData();
            formData.append('file', file[0]);
            this.errorData = [];
            this.$vs.loading();
            this.$crm.post(`/school-student/import`, formData).then(res => {
                this.$vs.loading.close();
                if (res.data && res.data.length > 0) {
                    this.popupErrorImport = true;
                    this.errorData = res.data.map(el => {
                        el.stt = res.data.indexOf(el) + 1;
                        return el;
                    });
                } else {
                    this.$vs.notify({
                        text: 'Nhập dữ liệu thành công!',
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    });
                    this.searchData();
                }
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
            this.$refs.fileUpload.value = null;
        },

        confirmDeleteMultiple() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá ${this.dataSelected.length} học sinh đã chọn không ?`,
                accept: this.deleteMultiple,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },

        async deleteMultiple() {
            this.$vs.loading();
            this.$crm.post('/school-student/delete', this.dataSelected).then(() => {
                this.isSelected = false;
                this.$vs.loading.close();
                this.$vs.notify({
                    text: 'Xóa học sinh thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.searchData();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },


        onRowSelected(event) {
            this.isSelected = !!(event.api.getSelectedNodes().length > 0);
            if (this.isSelected) {
                this.dataSelected = event.api.getSelectedNodes().map(x => {
                    return x.data.id;
                });
            } else {
                this.dataSelected = [];
            }
        }


    },
    // mounted() {
    //     this.gridApi = this.gridOptions.api;
    // },
}
</script>

<style scoped>
.f-r {
    float: right;
}
</style>

<style lang="scss">
.ag-paging-panel {
    display: none;
}
</style>
